import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { FolderForm } from './FolderForm';
import { FolderTree } from './FolderTree';
import { Wrapper } from './Material.styles';

import { Icon } from '@/components/Icon';
import { useCourseDetail, useFolderForm, useProfile } from '@/store';

export const Material = () => {
  const { t } = useTranslation('CourseTranslations');
  const { course } = useCourseDetail();
  const { setIsOpen } = useFolderForm();
  const {
    roleCheck: { isManager }
  } = useProfile();

  if (!course) return null;

  return (
    <Wrapper>
      <div>
        {isManager && (
          <Button icon={<Icon i="AddAlt" />} onClick={() => setIsOpen(true)}>
            {t('NEW_SECTION')}
          </Button>
        )}
      </div>
      <FolderTree />
      <FolderForm />
    </Wrapper>
  );
};
